import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate, useParams } from "react-router-dom";
import { invoiceStatus } from "../services/invoicePayment";
import Logo from "../assets/images/payloft-logo.png";
import AnimateSpinner from "../components/AnimateSpinner";

const InvoiceResult = () => {
  const { id } = useParams();
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  const decodedCode = atob(code);

  const paymentStatus = useCallback(async () => {
    console.log(id);
    setLoading(true);
    try {
      const res = await invoiceStatus(id);
      setStatus(res.data);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  }, [id]);

  useEffect(() => {
    paymentStatus();
  }, [paymentStatus]);

  const downloadReceipt = () => {
    const receiptElement = document.getElementById("receipt");

    html2canvas(receiptElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Scale down the image if it's taller than the page height
      const scaledHeight = imgHeight > pageHeight ? pageHeight : imgHeight;
      const scaledWidth = (canvas.width * scaledHeight) / canvas.height;

      // Center the content on the page
      const xOffset = (pageWidth - scaledWidth) / 2;
      const yOffset = (pageHeight - scaledHeight) / 2;

      pdf.addImage(imgData, "PNG", xOffset, yOffset, scaledWidth, scaledHeight);
      pdf.save("receipt.pdf");
    });
  };

  const navigateUser = () => {
    navigate(`/payment-invoice?code=${decodedCode}`);
  };

  return (
    <div className="bg-arena-background h-min-screen flex justify-center">
      <div className="bg-white w-[448px] h-auto" id="receipt">
        <div className="flex justify-center">
          <img src={Logo} alt="logo" className="w-[92px] h-auto mt-8 " />
        </div>
        <div className="mt-8 flex justify-center text-center">
          <p className="text-[18.75px] w-[348px] text-paragraph-text">
            Payment of the amount has been confirmed
          </p>
        </div>
        {loading ? (
          <div className="flex justify-center mt-8">
            <AnimateSpinner />
          </div>
        ) : status?.transactionStatus?.Status === "APPROVED" ? (
          <div>
            <div className="flex justify-center mt-8">
              <svg
                width="70"
                height="71"
                viewBox="0 0 70 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.000203981 35.2495C0.000204064 33.3475 0.143729 31.4097 0.466667 29.4719C2.83488 14.7948 14.7477 2.84505 29.4234 0.476627C48.2974 -2.57362 66.0948 9.59149 69.8983 28.2159C70.1854 29.6872 69.2524 31.0868 67.8171 31.4097C66.346 31.6968 64.9466 30.7638 64.6237 29.3284C61.3943 13.5748 46.3238 3.23979 30.2846 5.85942C17.8694 7.86899 7.7866 17.9528 5.77721 30.3691C3.1937 46.4815 13.5636 61.5175 29.3875 64.7113C30.8587 64.9983 31.7916 66.4338 31.5046 67.8692C31.2175 69.3405 29.7822 70.2735 28.347 69.9864C11.5901 66.5773 0.000203252 51.9361 0.000203981 35.2495Z"
                  fill="#27AE60"
                />
                <path
                  d="M33.1117 46.907C32.2442 46.907 31.4201 46.56 30.8129 45.9527L23.9597 39.1423C22.7019 37.8843 22.6585 35.8021 23.9597 34.5442C25.2176 33.2862 27.2996 33.2428 28.5574 34.5442L32.9382 38.882L45.5168 24.1768C46.6879 22.7886 48.7265 22.6585 50.1145 23.8297C51.4591 25.0009 51.6326 27.0397 50.4615 28.4278L35.6274 45.7792C35.0202 46.4732 34.1961 46.8636 33.2852 46.907C33.1985 46.907 33.1551 46.907 33.1117 46.907Z"
                  fill="#27AE60"
                />
              </svg>
            </div>
            <div className="flex flex-col items-center mt-8">
              <p className="w-[240.45px] text-2xl font-semibold text-dark-grey text-center">
                Transaction Successful
              </p>
              <p className="text-dark-grey text-sm font-normal">
                Your transaction was successful
              </p>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex justify-center mt-8">
              <svg
                width="70"
                height="71"
                viewBox="0 0 70 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.000166306 36.0646C0.000166389 34.1628 0.143698 32.2251 0.466643 30.2874C2.83492 15.6113 14.7481 3.66226 29.4242 1.29398C48.2987 -1.75607 66.0967 10.4083 69.9003 29.0315C70.1873 30.5027 69.2544 31.9022 67.819 32.2251C66.3478 32.5122 64.9484 31.5792 64.6255 30.1439C61.396 14.3913 46.3251 4.05697 30.2854 6.67643C17.8699 8.68588 7.78678 18.769 5.77733 31.1845C3.19375 47.296 13.5639 62.331 29.3883 65.5246C30.8595 65.8116 31.7925 67.2469 31.5054 68.6823C31.2184 70.1535 29.7831 71.0864 28.3477 70.7994C11.5904 67.3905 0.000165577 52.7502 0.000166306 36.0646Z"
                  fill="#FF0000"
                />
                <path
                  d="M47.8433 24.0003C46.9677 23.1247 45.5522 23.1247 44.6766 24.0003L36.5004 32.1598L28.3234 23.9829C27.4478 23.1073 26.0323 23.1073 25.1567 23.9829C24.2811 24.8584 24.2811 26.274 25.1567 27.1496L33.3333 35.3262L25.1567 43.5028C24.2811 44.3783 24.2811 45.7939 25.1567 46.6695C26.0323 47.5451 27.4478 47.5451 28.3234 46.6695L36.5 38.4929L44.6766 46.6695C45.5522 47.5451 46.9677 47.5451 47.8433 46.6695C48.7189 45.7939 48.7189 44.3783 47.8433 43.5028L39.6667 35.3262L47.8433 27.1496C48.7014 26.2914 48.7014 24.8584 47.8433 24.0003Z"
                  fill="#FF0000"
                  stroke="#FF0000"
                />
              </svg>
            </div>
            <div className="flex flex-col items-center mt-8">
              <p className="w-[240.45px] text-2xl font-semibold text-dark-grey text-center">
                Transaction Unsuccessful
              </p>
              <p className="text-dark-grey text-sm font-normal">
                Your transaction was not successful
              </p>
            </div>
          </div>
        )}
        <div className="px-4 mt-8">
          <p className="text-btn-blue text-base font-medium">Payment Details</p>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">Amount</p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.currencySymbol}
              {status?.transactionStatus?.Amount}
            </p>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Transaction Fee
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.currencySymbol}
              {status?.transactionStatus?.["Convenience Fee"]}
            </p>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">Scheme</p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.transactionStatus?.Scheme}
            </p>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Invoice Number
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.invoiceNumber}
            </p>
          </div>
          {status?.transactionStatus?.PAN && (
            <div className="flex justify-between mt-4">
              <p className="font-normal text-[13px] text-dark-grey">PAN</p>
              <p className="text-[13px] text-dark-grey font-medium">
                {status?.transactionStatus?.PAN}
              </p>
            </div>
          )}
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Transaction Time
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.transactionStatus?.TranDateTime}
            </p>
          </div>
          {status?.transactionStatus?.["Order Id"] && (
            <div className="flex justify-between mt-4">
              <p className="font-normal text-[13px] text-dark-grey">Order Id</p>
              <p className="text-[13px] text-dark-grey font-medium">
                {status?.transactionStatus?.["Order Id"]}
              </p>
            </div>
          )}
          {status?.transactionStatus?.["Approval Code"] && (
            <div className="flex justify-between mt-4">
              <p className="font-normal text-[13px] text-dark-grey">
                Approval Code
              </p>
              <p className="text-[13px] text-dark-grey font-medium">
                {status?.transactionStatus?.["Approval Code"]}
              </p>
            </div>
          )}

          {status?.transactionStatus?.CustomerName && (
            <div className="flex justify-between mt-4">
              <p className="font-normal text-[13px] text-dark-grey">
                Customer Name
              </p>
              <p className="text-[13px] text-dark-grey font-medium">
                {status?.transactionStatus?.CustomerName}
              </p>
            </div>
          )}

          {status?.transactionStatus?.CustomerEmail && (
            <div className="flex justify-between mt-4">
              <p className="font-normal text-[13px] text-dark-grey">
                Customer Email
              </p>
              <p className="text-[13px] text-dark-grey font-medium">
                {status?.transactionStatus?.CustomerEmail}
              </p>
            </div>
          )}

          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Description
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.transactionStatus?.Description}
            </p>
          </div>

          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Status Description
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              {status?.transactionStatus?.StatusDescription}
            </p>
          </div>

          <div className="flex justify-between mt-4 border-b-2 pb-4 border-dashed">
            <p className="font-normal text-[13px] text-dark-grey">
              Payment Status
            </p>
            <div className="flex items-center gap-1">
              {status?.transactionStatus?.Status === "APPROVED" && (
                <span>
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.99967 1.98926C4.32634 1.98926 1.33301 4.98259 1.33301 8.65592C1.33301 12.3293 4.32634 15.3226 7.99967 15.3226C11.673 15.3226 14.6663 12.3293 14.6663 8.65592C14.6663 4.98259 11.673 1.98926 7.99967 1.98926ZM11.1863 7.12259L7.40634 10.9026C7.31301 10.9959 7.18634 11.0493 7.05301 11.0493C6.91967 11.0493 6.79301 10.9959 6.69967 10.9026L4.81301 9.01592C4.61967 8.82259 4.61967 8.50259 4.81301 8.30926C5.00634 8.11592 5.32634 8.11592 5.51967 8.30926L7.05301 9.84259L10.4797 6.41592C10.673 6.22259 10.993 6.22259 11.1863 6.41592C11.3797 6.60926 11.3797 6.92259 11.1863 7.12259Z"
                      fill="#23A26D"
                    />
                  </svg>
                </span>
              )}
              <p className="text-[13px] text-dark-grey font-medium">
                {status?.transactionStatus?.Status}
              </p>
            </div>
          </div>

          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Total Payment
            </p>
            <p className="text-base text-dark-grey font-bold">
              {status?.currencySymbol}
              {(
                Number(status?.transactionStatus?.Amount) +
                Number(status?.transactionStatus?.["Convenience Fee"])
              ).toFixed(2)}
            </p>
          </div>
        </div>
        <div className="flex justify-center mt-10">
          {status?.transactionStatus?.Status === "APPROVED" ? (
            <button
              className="border bg-btn-blue text-white w-[307px] rounded-[10px] h-[65.38px]"
              onClick={downloadReceipt}
            >
              Download Receipt
            </button>
          ) : (
            <button
              className="border bg-btn-blue text-white w-[307px] rounded-[10px] h-[65.38px]"
              onClick={navigateUser}
            >
              Retry Transaction
            </button>
          )}
        </div>
        <p className="text-center text-base font-normal text-navy-blue mt-5 mb-5">
          Powered by Payloft
        </p>
      </div>
    </div>
  );
};

export default InvoiceResult;
